var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-drawer',{attrs:{"title":_vm.title,"visible":_vm.visible,"maskClosable":false,"body-style":{ paddingBottom: '80px' },"width":"1000px"},on:{"close":_vm.handleCancel}},[_c('div',[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data}})],1),_c('div',{style:({
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: '100%',
    borderTop: '1px solid #e9e9e9',
    padding: '10px 16px',
    background: '#fff',
    textAlign: 'right',
    zIndex: 1,
  })},[_c('a-button',{staticStyle:{"margin-left":"10px"},on:{"click":_vm.handleCancel}},[_vm._v(" 关闭 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }